import { Modal, ModalCloseButton, ModalContent, ModalTitle } from '../../../../../../design-system/modal/modal';
import { PdfViewer } from '../../../../../../design-system/pdf-viewer/pdf-viewer';

type EvidenceViewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  signedUrl: string | null;
  fileName: string | null;
};

export const EvidenceViewModal = ({ isOpen, onClose, signedUrl, fileName }: EvidenceViewModalProps) => {
  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <ModalContent className="h-[90vh] w-[90vw] max-w-none px-5 py-4" aria-describedby={`View file:${fileName}`}>
        <ModalTitle>View Evidence</ModalTitle>
        <ModalCloseButton />
        {signedUrl && <PdfViewer url={signedUrl} fileName={fileName || 'Document'} showDownloadButton={true} />}
      </ModalContent>
    </Modal>
  );
};
